import { useEffect, useState } from "react";
import sleep from "./img/home/sleep.png";

const fetchSFX = (str) => new Audio(`./sfx/${str}.mp3`);
const weatherIDs = {
  sunny: 1,
  cloudy: 3,
  stormy: 5,
  // ^ figured out

  snowy: 2,
  rainy: 4,
  foggy: 6,
  partlycloudy: 7,
};

export default function Announce(props) {
  const [isPlaying, setIsPlaying] = useState(false);
  let playStack = [];

  function play() {
    if (isPlaying) return;
    setIsPlaying(true);
  }

  async function parseStack() {
    const playAudio = (audio) => {
      return new Promise((res) => {
        audio.volume = 0.5;
        audio.play();
        audio.onended = res;
      });
    };

    for (let i = 0; i < playStack.length; i++) {
      await playAudio(playStack[i]);
    }

    //// setIsPlaying(false);
  }

  function playBGMusic(id) {
    const bgMusic = new Audio(`./music/m${id}.mp3`);
    bgMusic.volume = 0.25;
    bgMusic.oncanplaythrough = () => {
      bgMusic.play();
      setTimeout(parseStack, 5000);
      bgMusic.onended = () => setIsPlaying(false);
    };
  }

  useEffect(() => {
    // Prevent firing on load
    if (!isPlaying) return;

    playStack = [
      fetchSFX(`greet_${props.hr < 13 ? "goodmorning" : "hello"}`),
      fetchSFX("its"),
      fetchSFX(`hour_${props.hr % 12 !== 0 ? props.hr % 12 : "12"}`),
      fetchSFX(`min_${props.min}`),
      fetchSFX(`ampm_${props.hr < 12 ? "am" : "pm"}`),
      fetchSFX(`week_${props.day}`),
    ];

    if (props.weather) playStack.push(fetchSFX(`music_${props.weather}`));

    playBGMusic(weatherIDs[props.weather] || 1);
  }, [isPlaying]);

  return (
    <div>
      <img
        className="announce"
        src={sleep}
        onClick={play}
        alt="Click to announce time"
      />
      <div className="status">{isPlaying ? "Wait" : "Ready"}</div>
    </div>
  );
}
